import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {IPolyBetLineConfig, IPolyBetLineStyle, PolyBetLine} from "@nolimitcity/slot-game/bin/game/betline/line/PolyBetLine";
import {TombOfNefertitiHelper} from "../../utils/TombOfNefertitiHelper";
import {TombOfNefertitiAnimatedWinlineController} from "../../winpresentation/animatedwinlines/TombOfNefertitiAnimatedWinlineController";

export class TombOfNefertitiPolyBetline extends PolyBetLine {

    /**
     * @description Overridden this method so that the betline can get the position as per individual reel not as 5 * 3 but as 15 * 1.
     *
     * @param numberPosition
     * @param betLineData
     * @param config
     */
    protected draw(numberPosition:number[], betLineData:number[], config:IPolyBetLineConfig):void {
        const linePositions:number[][] = [];

        let offsetX:number;

        // checking for free spin betline number so that the start point is after the betline number not on the number itself.
        if(this.index > 20) {
            offsetX = 55;
        } else {
            offsetX = config.numberOffsetX;
        }

        // number on the left, use it's position to start.
        if(numberPosition[2] === 0) {
            linePositions.push([numberPosition[0] + offsetX, numberPosition[1]]);
        }

        for(let j:number = 0; j < betLineData.length; j++) {
            const symId:number = betLineData[j];
            const basePosition:number[] = TombOfNefertitiHelper.getSymbolPositions(j, symId);
            // TODO: handle the offset in betline subclasses?
            // if(j > 0 && symId === this._betLinesData[dataIndex][j - 1]){
            //     // if the current point is in the same level as the previous one, use the same y position.
            //     basePosition[1] = linePositions[linePositions.length - 1][1];
            // }else{
            //     basePosition[1] += symbolHeight / 2 + offsetFactor[j][symId] *
            // this._config.linePointOverlapVerticalOffset; } offsetFactor[j][symId] += 1;
            linePositions.push(basePosition);
        }

        // number on the right, use it's position to end the line
        if(numberPosition[2] === 1) {
            linePositions.push([numberPosition[0] - offsetX, numberPosition[1]]);
        }

        // Draw the line.
        let line:PIXI.Graphics | null = new PIXI.Graphics();
        let lineWidth:number = 0;

        for(let i:number = 0; i < config.styles.length; i++) {
            this.drawPolylineTON(line, linePositions, config.styles[i]);
            lineWidth = Math.max(lineWidth, config.styles[i].lineWidth);
        }

        // TODO: #372
        // // If WebGL we need to render Graphics with the Canvas renderer to get anti-aliasing
        // if(StageManager.isWebGLSupported == true && UserAgent.forceCanvas == false) {
        //     let resolution:number = StageManager.devicePixelRatio;
        //     //Low resolution on mobile
        //     if(UserAgent.isMobile) {
        //         resolution = 0.5;
        //     }
        //     const sprite:PIXI.Sprite = new PIXI.Sprite(Helper.generateCanvasTexture(line, resolution));
        //     line = null;
        //     sprite.x = linePositions[0][0] - lineWidth * 3 / 2;
        //     sprite.y = this.getHighestPointYTON(linePositions) - lineWidth;
        //     this.addChild(sprite);
        // } else {
        //     this.addChild(line);
        // }
        this.addChild(line);

        StageManager.getLayer(config.staticLineLayer).addChild(this);
        this.alpha = 0;
    }

    protected showStatic():void {
        EventHandler.dispatchEvent(new GameEvent(TombOfNefertitiAnimatedWinlineController.CLEAN_UP_ANIMATED_WINLINE));

        EventHandler.dispatchEvent(new GameEvent(TombOfNefertitiAnimatedWinlineController.PLAY_ANIMATED_WINLINE, (this.index - 1), true));
    }

    protected showWin():void {
        EventHandler.dispatchEvent(new GameEvent(TombOfNefertitiAnimatedWinlineController.PLAY_ANIMATED_WINLINE, (this.index - 1)));
    }

    protected hideAll():void {
        EventHandler.dispatchEvent(new GameEvent(TombOfNefertitiAnimatedWinlineController.CLEAN_UP_ANIMATED_WINLINE));
    }

    private drawPolylineTON(line:PIXI.Graphics, points:number[][], style:IPolyBetLineStyle):void {
        line.lineStyle(style.lineWidth, style.color, style.alpha);
        line.moveTo(points[0][0], points[0][1]);
        for(let i:number = 1; i < points.length; i++) {
            line.lineTo(points[i][0], points[i][1]);
        }
    }

    private getHighestPointYTON(points:number[][]):number {
        let y:number = points[0][1];
        for(let i:number = 1; i < points.length; i++) {
            y = Math.min(y, points[i][1]);
        }

        return y;
    }
}